// @flow
import React from 'react';

// Stands in for a day's appointments until its week or month has loaded
const AppointmentSkeleton = () => (
  <div className="agenda-skeleton" aria-hidden="true">
    <span className="agenda-skeleton-card" />
  </div>
);

export default AppointmentSkeleton;
